export enum ActionType {
  ContainerMove = 'CONTAINER_MOVE',
  ContainerWeighing = 'CONTAINER_WEIGHTING',
  NewContainer = 'NEW_CONTAINER',
  NewIncident = 'NEW_INCIDENT',
}

const actionTypeLabels = {
  [ActionType.ContainerMove]: 'Déplacement de bac',
  [ActionType.ContainerWeighing]: 'Pesée de bac',
  [ActionType.NewContainer]: 'Ajout de bac',
  [ActionType.NewIncident]: "Signalement d'incident"
}

export interface Action {
  type: ActionType
  containerCode?: string
  payload: Object
}

export const getActionTypeLabel = (action: Action) => {
  return actionTypeLabels[action.type]
}
